function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 16V18H18C18.55 18 19.0208 17.8042 19.4125 17.4125C19.8042 17.0208 20 16.55 20 16V4C20 3.45 19.8042 2.97917 19.4125 2.5875C19.0208 2.19583 18.55 2 18 2H17V0H15V2H7V0H5V2H4C3.45 2 2.97917 2.19583 2.5875 2.5875C2.19583 2.97917 2 3.45 2 4V8H4H18V16H12ZM18 6H4V4H18V6ZM1.4625 18.5375C2.4375 19.5125 3.61667 20 5 20C6.38333 20 7.5625 19.5125 8.5375 18.5375C9.5125 17.5625 10 16.3833 10 15C10 13.6167 9.5125 12.4375 8.5375 11.4625C7.5625 10.4875 6.38333 10 5 10C3.61667 10 2.4375 10.4875 1.4625 11.4625C0.487501 12.4375 0 13.6167 0 15C0 16.3833 0.487501 17.5625 1.4625 18.5375ZM7.35 16.65L6.65 17.35L4.5 15.2V12H5.5V14.8L7.35 16.65Z",
  fill: "#B1C3CC"
});

var SvgLateDate = function SvgLateDate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLateDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/late_date.a1cc7508.svg";
export { ForwardRef as ReactComponent };